module.exports = __webpack_public_path__ + "img/visa.29512be.svg";